export default __webpack_public_path__ + "static/media/mountains.71e46d25.png";